module.exports = __webpack_public_path__ + "assets/img/1.75a183d4.png";